import { createContext } from 'react';

import { WorkflowV1QueryWorkflowInstancePermissionsResponse } from '@spotify/confidence-graphql';

export type WorkflowPermissionContextType =
  WorkflowV1QueryWorkflowInstancePermissionsResponse;

export const WorkflowPermissionContext =
  createContext<WorkflowPermissionContextType | null>({
    isAllAllowed: false,
    actionPermissionCheckResults: [],
    functionPermissionCheckResults: [],
  });
